
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12442',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12442",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.477",
  "data-fetching-client": "static-1.9722",
  "foundations-components": "static-1.8039",
  "foundations-components-legacy": "static-1.1064",
  "foundations-theming": "static-1.4483",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8073",
  "hub-http-shared-msw-handlers": "static-1.10099",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11530",
  "I18n": "static-7.1633",
  "jasmine-runner": "static-1.6520",
  "marketplace-storefront-base": "static-1.12504",
  "quartz": "static-1.7099",
  "react-dlb": "static-1.80",
  "react-rhumb": "static-1.16736",
  "reactive-variable-buffer-atom": "static-1.2915",
  "reporting-testing-lib": "static-1.9729",
  "settings-ui-lib": "static-1.12577",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7243",
  "ui-addon-i18n": "static-1.11208",
  "ui-addon-react-router-dom": "static-1.9599",
  "unified-auth": "static-1.561",
  "unified-auth-core-lib": "static-1.843",
  "usage-tracker": "static-1.7407",
  "usage-tracker-core": "static-1.7257",
  "customer-data-property-utils": "static-1.8151",
  "hub-http": "static-1.6279",
  "integrations-lib": "static-1.16346",
  "marketplace-ui-common": "static-1.19974",
  "property-management-iframe": "static-1.13350",
  "quartz-config": "static-1.877",
  "quartz-core": "static-1.6318",
  "quartz-routing": "static-1.529",
  "quick-fetch": "static-1.3962",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4709",
  "ts-schema": "static-1.4124",
  "ui-universal-auth": "static-1.9047",
  "UIComponents": "static-3.8476",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3443",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3376",
  "quartz-webpack": "static-1.3323",
  "bend-plugin-quartz-routing": "static-1.177",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4308",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4927",
  "foundations-theming-specialty": "static-1.2199",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9480",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5388",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.488",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2088",
  "ui-fonts": "static-1.792",
  "ui-images": "static-2.1166",
  "bend-plugin-foundations-theming": "static-1.2966",
  "foundations-theming-base": "static-1.3468",
  "stylex": "static-1.34",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3184",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4382",
  "ai-components-ui-library": "static-1.9108",
  "ai-rendering-library": "static-1.10365",
  "chirp-fetch": "static-1.1944",
  "connections-embed-lib": "static-1.1102",
  "copilot-toolkit": "static-1.11285",
  "feedback-loader": "static-1.29399",
  "laboratory-lib": "static-3.7212",
  "marketplace-embed": "static-1.22253",
  "marketplace-ui-details": "static-1.9869",
  "marketplace-ui-reviews": "static-1.19929",
  "marketplace-ui-tracking": "static-1.14144",
  "sanitize-text": "static-1.8201",
  "ui-addon-video-player": "static-1.8761",
  "usage-tracker-multi": "static-1.5821",
  "usage-tracker-session-replay": "static-1.5093",
  "wootric-nps": "static-1.7026",
  "quartz-head": "static-1.764",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4709",
  "immer": "static-1.33",
  "immerable": "static-1.4210",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2528",
  "reporting-data": "static-1.67796",
  "cssUtils": "static-1.807",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11837",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10267",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10422",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7397",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18506",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4570",
  "foundations-components-test-utils": "static-1.5522",
  "quartz-i18n": "static-1.774",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.76",
  "google-sheets-integration-lib": "static-1.398",
  "microsoft-drive-integration-lib": "static-1.536",
  "slack-ui-library": "static-1.10449",
  "fsm": "static-1.3787",
  "customer-data-objects": "static-1.7734",
  "property-translator": "static-1.5456",
  "hs-locale-management": "static-1.125",
  "frontend-preferences-client": "static-1.7984",
  "hs-promise-utils": "static-1.5649",
  "hubspot-apollo-client": "static-1.4934",
  "integrations-error-boundary-lib": "static-1.13761",
  "integrations-tracking-lib": "static-1.5662",
  "native-integrations-shared-strings": "static-1.7838",
  "reselect": "static-2.16",
  "sanitize": "static-1.4534",
  "superstore": "static-1.4818",
  "ui-shepherd-react": "static-3.10273",
  "ai-settings-ui-library": "static-1.7973",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4695",
  "immutable-less": "static-1.4709",
  "marketplace-ui-client-types": "static-1.17381",
  "nav-meta": "static-1.29812",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10305",
  "ui-addon-upgrades": "static-9.18079",
  "inbound-db-properties-service-client": "static-1.3888",
  "property-management-common": "static-1.5638",
  "ui-addon-iframeable": "static-1.9117",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.774",
  "quartz-test": "static-1.774",
  "quartz-tracking": "static-1.478",
  "trellis-components": "static-1.2107",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.119",
  "bender-build-tools": "static-1.3254",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21550",
  "ContentUtils": "static-1.68528",
  "customer-data-objects-ui-components": "static-1.13090",
  "sassPrefix": "static-1.157",
  "breeze-engine-core": "static-1.143",
  "breeze-onboarding-components": "static-1.147",
  "avatar-components": "static-1.2555",
  "customer-data-filters-ui": "static-1.39993",
  "customer-data-reference-ui-components": "static-1.13227",
  "embedded-academy-lib": "static-1.14531",
  "ExportDialog": "static-6.10442",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41457",
  "reporting-snowflake": "static-1.56414",
  "reporting-ui-components": "static-2.65067",
  "reporting-visualizations": "static-1.59872",
  "ui-addon-teams": "static-1.21631",
  "integrations-reconnect-lib": "static-1.75",
  "magpie-lib": "static-1.5590",
  "navigation-components": "static-1.18175",
  "breeze-engine-lib": "static-1.865",
  "magpie-types": "static-1.5050",
  "simple-logging-lib": "static-1.3107",
  "ai-studio-lib": "static-1.11774",
  "app-governance-lib": "static-1.1729",
  "developer-experience-shared-components": "static-1.10570",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8059",
  "ui-product-approvals": "static-1.28319",
  "ui-tool-access": "static-1.10206",
  "usage-based-billing-components-lib": "static-1.9204",
  "usage-tracker-anonymous": "static-1.5824",
  "usage-tracker-public": "static-1.7218",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3630",
  "persist-promise": "static-1.3756",
  "reference-resolvers": "static-1.8229",
  "ui-extensibility-client-types": "static-1.3982",
  "hubspot-apollo-cache": "static-1.393",
  "universal-page-editor-lib": "static-1.3075",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2933",
  "merchandise-lib": "static-1.265",
  "atom": "static-1.5131",
  "purchase-motions-components": "static-1.6021",
  "salesImages": "static-1.526",
  "batch-promise": "static-1.1599",
  "crm-component-utils": "static-1.39224",
  "crm-properties-common-lib": "static-1.5946",
  "customer-data-properties": "static-1.51781",
  "framework-data-schema-resolvers": "static-1.6947",
  "property-value-citations": "static-1.2395",
  "reference-resolvers-lite": "static-1.8156",
  "ui-business-units-lib": "static-1.9114",
  "navigation-messaging": "static-1.7502",
  "hubspotter-http-shared-msw-handlers": "static-1.10097",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.991",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4870",
  "content-icons-ui": "static-1.2242",
  "customer-data-ui-utilities": "static-1.9882",
  "conversations-skeleton-state": "static-1.7306",
  "crm-message-bus": "static-1.43115",
  "customer-data-filters-ui-msw-helpers": "static-1.22428",
  "events-data-lib": "static-1.287",
  "FormUrlGenerator": "static-2.4777",
  "framework-builder-read-service-client": "static-1.4049",
  "framework-data-schema-quick-fetch": "static-1.6852",
  "multi-account-reference-resolvers": "static-1.1040",
  "onboarding-tours": "static-1.16709",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13838",
  "academy-common-lib": "static-1.13991",
  "content-assistance-lib": "static-1.7838",
  "dashboard-lib": "static-1.81764",
  "file-manager-components": "static-1.23768",
  "getting-started-shared-tasks": "static-1.18574",
  "hubspot-prosemirror": "static-1.18384",
  "hubspot-prosemirror-plugins": "static-1.18376",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19923",
  "share-with-third-party-component-lib": "static-1.8762",
  "ui-addon-draggable": "static-3.4820",
  "ui-asset-management-lib": "static-1.11114",
  "user-context": "static-1.5165",
  "growth-payments-core": "static-1.25537",
  "reporting-plugins": "static-1.10412",
  "reporting-reports": "static-1.67474",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.781",
  "nest": "static-1.290",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10684",
  "framework-listing-lib": "static-2.28842",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30852",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4307",
  "ui-product-approvals-common": "static-1.214",
  "onboarding-scopes": "static-1.6518",
  "onboarding-tours-client": "static-1.4923",
  "platform-infra-nav-components": "static-1.7716",
  "subscription-experience-data-types": "static-1.15008",
  "crm-record-cards-service-types": "static-1.3634",
  "location-customization-utils-lib": "static-1.9423",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6024",
  "signup-constants": "static-1.18971",
  "signup-ui-url-generator": "static-2.8113",
  "card-properties-lib": "static-1.44361",
  "commerce-subscription-lib": "static-1.37279",
  "crm-actions": "static-1.6396",
  "crm-cards-sdk": "static-1.43750",
  "customer-data-properties-shared-msw-handlers": "static-1.9426",
  "customer-data-tracking": "static-1.6946",
  "hs-resources": "static-1.226",
  "pulse": "static-1.644",
  "calling-global-api": "static-1.64713",
  "calling-internal-common": "static-1.31362",
  "calling-lifecycle-internal": "static-1.66095",
  "calling-lifecycle-messages": "static-1.58389",
  "commerce-products-lib": "static-1.9764",
  "conditional-properties-service-client": "static-1.3841",
  "crm-links": "static-1.6364",
  "crm-pipelines-api-client-types": "static-1.4183",
  "external-options-client-types": "static-1.4199",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4266",
  "meetings-icalendar-utils-lib": "static-1.689",
  "multi-currency-client-types": "static-1.3736",
  "object-builder-ui-client": "static-1.48940",
  "pipeline-validation-client-types": "static-1.4010",
  "smart-property-lib": "static-1.7412",
  "tiered-pricing": "static-1.1346",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11047",
  "fdsr-migration-layer": "static-1.66",
  "react-dnd-compat": "static-1.4671",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1036",
  "growth-data-modal": "static-1.5515",
  "growth-onboarding-confetti": "static-1.3124",
  "growth-onboarding-next-action-utils": "static-1.2079",
  "onboarding-tours-utils": "static-1.775",
  "ui-shepherd-tracker": "static-1.7654",
  "academy-service-client": "static-1.3740",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39267",
  "FileManagerLib": "static-1.39408",
  "video-embed": "static-1.35966",
  "ui-coaching-tips": "static-1.28716",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11474",
  "video-data-lib": "static-1.35132",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8522",
  "payment-link-components": "static-1.23658",
  "ui-addon-emoji-picker": "static-1.9943",
  "EmailSignatureEditor": "static-1.24499",
  "viral-links-lib": "static-1.7127",
  "data-token-picker": "static-1.16504",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.284",
  "timezone-utils": "static-2.5300",
  "seat-types-lib": "static-1.146",
  "getting-started-shared-tasks-store": "static-1.17692",
  "ui-addon-opt": "static-4.8419",
  "campaign-roi-lib": "static-1.9259",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25571",
  "framework-data-table": "static-2.12047",
  "marketing-platform-lib": "static-1.6919",
  "nudge-client-utils": "static-1.2705",
  "nudge-custom-ui-functions": "static-1.1134",
  "switchboard-lib": "static-1.280",
  "app-users-service-client": "static-1.5662",
  "app-users-service-types": "static-1.5070",
  "mini-checkout-client": "static-1.26944",
  "onboarding-utils": "static-1.5415",
  "permissions-shared-i18n-strings-fe": "static-1.2056",
  "ui-coaching-tips-shared-config": "static-1.28701",
  "edison-service-client-types": "static-1.446",
  "crm_data": "static-4.92145",
  "customer-data-sidebar": "static-2.46170",
  "enrichment-properties-lib": "static-1.16530",
  "ui-addon-draggable-compat": "static-2.4315",
  "commerce-billing-lib": "static-1.19261",
  "commerce-shared-components-lib": "static-1.18668",
  "commerce-tools-ui-lib": "static-1.10526",
  "crm-fe-perf": "static-1.22960",
  "event-emitter": "static-1.1006",
  "bend-plugin-pulse": "static-1.147",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31369",
  "shared-worker-versioning": "static-1.11094",
  "calling-usage-tracker": "static-1.6598",
  "voice-sms-access-library": "static-1.1223",
  "commerce-permissions": "static-1.832",
  "products-iframe-lib": "static-1.8089",
  "products-ui-components-shared-msw-handlers": "static-1.10481",
  "data-agent-kit": "static-1.283",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10182",
  "policy-lib": "static-1.6836",
  "react-tinymce": "static-1.55397",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10245",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54523",
  "tinymce-plugins": "static-1.57637",
  "tinymce-themes": "static-1.56493",
  "onboarding-data-sync-lib": "static-1.2058",
  "growth-onboarding-next-action-components": "static-1.2107",
  "user-context-client": "static-1.4655",
  "audio-components": "static-1.5997",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36919",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4594",
  "video-components": "static-1.13476",
  "outpost": "static-1.4232",
  "growth-onboarding-feedback-components": "static-1.6637",
  "content-media-composition-data-lib": "static-1.12541",
  "content-media-compositions": "static-2.16548",
  "media-bridge-lib": "static-1.19021",
  "commerce-tours-lib": "static-1.6206",
  "growth-onboarding-reliability": "static-1.5137",
  "sales-checkout-service-client": "static-1.3689",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21772",
  "sales-email-signature-service-client": "static-1.3905",
  "ts-utils-lib": "static-1.228",
  "crm-export-dialog": "static-1.6347",
  "crm-index-associations-lib": "static-1.6500",
  "crm-view-components": "static-1.444",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7385",
  "nudge-custom-function-registry": "static-1.2462",
  "nudge-renderer-utils": "static-1.2781",
  "whisper-core-api": "static-1.6779",
  "InboxConnectUtils": "static-4.14964",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5677",
  "settings-content-modals": "static-1.46244",
  "crm_universal": "static-1.22104",
  "customer-data-email": "static-1.18131",
  "card-payment-highlight-lib": "static-1.37329",
  "card-subscription-highlight-lib": "static-1.39702",
  "commerce-contract-lib": "static-1.12302",
  "invoices-highlight-card-lib": "static-1.54891",
  "orders-highlight-card-lib": "static-1.21620",
  "products-highlight-card-lib": "static-1.18047",
  "quotes-highlight-card-lib": "static-1.72222",
  "crm-source-interpretation-lib": "static-1.5401",
  "utility-belt": "static-1.2591",
  "payments-enrollment-embed-lib": "static-1.23044",
  "stripe-embedded-components": "static-1.7605",
  "customer-data-rte": "static-1.33146",
  "cv-backend-services": "static-1.1555",
  "growth-onboarding-empty-states": "static-1.5840",
  "payments-post-enroll-local-storage-lib": "static-1.5165",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38312",
  "trials-service-types": "static-1.3957",
  "calling-orchestration-schema": "static-1.36000",
  "sales-views-client-types": "static-1.4315",
  "hub-http-contrib": "static-1.3098",
  "interframe": "static-3.4816",
  "tinymce-data": "static-1.40608",
  "ui-addon-sales-email": "static-1.5268",
  "layout-dnd-components": "static-1.12553",
  "layout-dnd-utils": "static-1.11528",
  "ui-brand-identity-lib": "static-1.15494",
  "NamespacedHubStyle": "static-2.9102",
  "meetings-connect-utils-lib": "static-1.7661",
  "social-insights-client-types": "static-1.22242",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4214",
  "checkout-sdk": "static-3.23787",
  "checkout-service-types": "static-1.3846",
  "company-details-components": "static-1.6253",
  "payment-method-components": "static-1.6951",
  "pricing-pages-ui-components": "static-1.14315",
  "quote-checkout-service-types": "static-1.3522",
  "upgrade-catalog-service-types": "static-1.3578",
  "access-control-lib": "static-1.10491",
  "EmailComponents": "static-1.54914",
  "EmailData": "static-1.53591",
  "redux-less": "static-2.9541",
  "sequences-lib": "static-1.8140",
  "ui-gdpr-components": "static-1.10406",
  "products-ui-components": "static-1.40282",
  "accounting-integrations-ui-components": "static-1.7153",
  "invoices-ui-lib": "static-1.54907",
  "commerce-products-api": "static-1.2383",
  "invoices-iframe-lib": "static-1.56965",
  "quotes-modal-lib": "static-1.102900",
  "quotes-ui-lib": "static-1.80943",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28418",
  "ContentData": "static-1.68603",
  "layout-data-lib": "static-1.9853",
  "hub-http-rxjs": "static-1.805",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3996",
  "billing-payments-client-types": "static-1.4049",
  "react-performance-metrics-lib": "static-1.614",
  "account-and-billing-fintech-outages": "static-3.18662",
  "pricing-pages-api": "static-1.14180",
  "ContentComponents": "static-2.71484",
  "marketing-contacts-lib": "static-1.10245",
  "marketing-email-service-types": "static-1.1938",
  "messaging-editing-lib": "static-1.46432",
  "messaging-usage-based-billing-components-lib": "static-1.1294",
  "automation-ui-source-apps": "static-1.19039",
  "automation-ui-types": "static-1.19957",
  "messaging-types-lib": "static-1.46169",
  "onboarding-settings-client": "static-1.4561",
  "sequences-client-types-lib": "static-1.7997",
  "commerce-tax-lib": "static-1.590",
  "price-books-api": "static-1.1041",
  "price-books-components": "static-1.1099",
  "property-description-translator": "static-1.3900",
  "ramp-editor": "static-1.280",
  "commerce-analytics-service-client": "static-1.3677",
  "totals-ui-components": "static-1.23760",
  "SalesContentIndexUI": "static-3.9334",
  "advanced-menus-core": "static-1.15216",
  "advanced-menus-lib": "static-1.12151",
  "ui-memberships-settings-lib": "static-1.34197",
  "segments-query-core": "static-1.1475",
  "eligibility-engine-service-types": "static-1.3238",
  "automation-ui-ubb": "static-1.5873",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7396",
  "data-token-views": "static-1.16485",
  "forms-utils-lib": "static-1.12689",
  "payments-embed-points-lib": "static-1.13151",
  "simple-menus-core": "static-1.15215",
  "simple-menus-lib": "static-1.16732",
  "videoconference-integration-components": "static-1.6906",
  "marketing-contacts-client": "static-1.7572",
  "automation-applications-service-types": "static-1.3560",
  "automation-platform-service-types": "static-1.2604",
  "ContentEditorUI": "static-2.77257",
  "short-messages-app-service-client": "static-1.4027",
  "web-interactives-components": "static-1.13855",
  "web-interactives-data": "static-1.13856",
  "messaging-shared-utils-lib": "static-1.743",
  "messaging-user-info-utils-lib": "static-1.913",
  "email-portal-health-service-types": "static-1.1036",
  "line-items-api": "static-1.784",
  "commerce-totals-service-types": "static-1.3863",
  "FireAlarmUi": "static-1.4557",
  "sales-templates-service-types-lib": "static-1.4214",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21893",
  "automation-ui-usage-tracking": "static-1.21356",
  "data-studio-ubb": "static-1.2882",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27163",
  "collaboration-sidebar": "static-1.57975",
  "content-management-data-lib": "static-1.5465",
  "copilot-plugins": "static-1.11258",
  "cta-picker": "static-1.36556",
  "customer-agent-discovery-components-lib": "static-1.3243",
  "editor-components": "static-1.13314",
  "editor-iframe-lib": "static-1.8485",
  "error-messaging-js": "static-1.5250",
  "FormsCommonComponents": "static-1.86004",
  "pictos": "static-7.185",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10703",
  "SharedLegalStrings": "static-1.1804",
  "smart-content-core": "static-1.42598",
  "smart-content-lib": "static-1.43251",
  "social-composer-lib": "static-1.59382",
  "structured-content-lib": "static-1.25343",
  "theme-previewer-lib": "static-1.53391",
  "tinymce-copilot": "static-1.16591",
  "xray-recommendation-lib": "static-1.7988",
  "automation-ui-routing": "static-1.21314",
  "sql-reporting-client-types": "static-1.5681",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42317",
  "campaigns-utils-lib": "static-1.3245",
  "reporting-enablement": "static-1.23121",
  "chatspot-widget-iframe": "static-1.21542",
  "collaboration-sidebar-common": "static-1.2772",
  "forms-ai-lib": "static-1.4404",
  "codemirror-dlb": "static-1.58816",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6490",
  "report-customization-components": "static-1.13322",
  "data-quality-ui-library": "static-1.13196",
  "reporting-filters": "static-1.472",
  "reporting-insights-lib": "static-1.1905"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12442",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.477",
  "data-fetching-client": "/data-fetching-client/static-1.9722",
  "foundations-components": "/foundations-components/static-1.8039",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1064",
  "foundations-theming": "/foundations-theming/static-1.4483",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8073",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10099",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11530",
  "I18n": "/I18n/static-7.1633",
  "jasmine-runner": "/jasmine-runner/static-1.6520",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12504",
  "quartz": "/quartz/static-1.7099",
  "react-dlb": "/react-dlb/static-1.80",
  "react-rhumb": "/react-rhumb/static-1.16736",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2915",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9729",
  "settings-ui-lib": "/settings-ui-lib/static-1.12577",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7243",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11208",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9599",
  "unified-auth": "/unified-auth/static-1.561",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.843",
  "usage-tracker": "/usage-tracker/static-1.7407",
  "usage-tracker-core": "/usage-tracker-core/static-1.7257",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8151",
  "hub-http": "/hub-http/static-1.6279",
  "integrations-lib": "/integrations-lib/static-1.16346",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19974",
  "property-management-iframe": "/property-management-iframe/static-1.13350",
  "quartz-config": "/quartz-config/static-1.877",
  "quartz-core": "/quartz-core/static-1.6318",
  "quartz-routing": "/quartz-routing/static-1.529",
  "quick-fetch": "/quick-fetch/static-1.3962",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4709",
  "ts-schema": "/ts-schema/static-1.4124",
  "ui-universal-auth": "/ui-universal-auth/static-1.9047",
  "UIComponents": "/UIComponents/static-3.8476",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3443",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3376",
  "quartz-webpack": "/quartz-webpack/static-1.3323",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.177",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4308",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4927",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2199",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9480",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5388",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2088",
  "ui-fonts": "/ui-fonts/static-1.792",
  "ui-images": "/ui-images/static-2.1166",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2966",
  "foundations-theming-base": "/foundations-theming-base/static-1.3468",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3184",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4382",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9108",
  "ai-rendering-library": "/ai-rendering-library/static-1.10365",
  "chirp-fetch": "/chirp-fetch/static-1.1944",
  "connections-embed-lib": "/connections-embed-lib/static-1.1102",
  "copilot-toolkit": "/copilot-toolkit/static-1.11285",
  "feedback-loader": "/feedback-loader/static-1.29399",
  "laboratory-lib": "/laboratory-lib/static-3.7212",
  "marketplace-embed": "/marketplace-embed/static-1.22253",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9869",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19929",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14144",
  "sanitize-text": "/sanitize-text/static-1.8201",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8761",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5821",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5093",
  "wootric-nps": "/wootric-nps/static-1.7026",
  "quartz-head": "/quartz-head/static-1.764",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4709",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4210",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2528",
  "reporting-data": "/reporting-data/static-1.67796",
  "cssUtils": "/cssUtils/static-1.807",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11837",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10267",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10422",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7397",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18506",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4570",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5522",
  "quartz-i18n": "/quartz-i18n/static-1.774",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.76",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.398",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.536",
  "slack-ui-library": "/slack-ui-library/static-1.10449",
  "fsm": "/fsm/static-1.3787",
  "customer-data-objects": "/customer-data-objects/static-1.7734",
  "property-translator": "/property-translator/static-1.5456",
  "hs-locale-management": "/hs-locale-management/static-1.125",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7984",
  "hs-promise-utils": "/hs-promise-utils/static-1.5649",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4934",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13761",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5662",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7838",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4534",
  "superstore": "/superstore/static-1.4818",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10273",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7973",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4695",
  "immutable-less": "/immutable-less/static-1.4709",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17381",
  "nav-meta": "/nav-meta/static-1.29812",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10305",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18079",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3888",
  "property-management-common": "/property-management-common/static-1.5638",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9117",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.774",
  "quartz-test": "/quartz-test/static-1.774",
  "quartz-tracking": "/quartz-tracking/static-1.478",
  "trellis-components": "/trellis-components/static-1.2107",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.119",
  "bender-build-tools": "/bender-build-tools/static-1.3254",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21550",
  "ContentUtils": "/ContentUtils/static-1.68528",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13090",
  "sassPrefix": "/sassPrefix/static-1.157",
  "breeze-engine-core": "/breeze-engine-core/static-1.143",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.147",
  "avatar-components": "/avatar-components/static-1.2555",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39993",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13227",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14531",
  "ExportDialog": "/ExportDialog/static-6.10442",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41457",
  "reporting-snowflake": "/reporting-snowflake/static-1.56414",
  "reporting-ui-components": "/reporting-ui-components/static-2.65067",
  "reporting-visualizations": "/reporting-visualizations/static-1.59872",
  "ui-addon-teams": "/ui-addon-teams/static-1.21631",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.75",
  "magpie-lib": "/magpie-lib/static-1.5590",
  "navigation-components": "/navigation-components/static-1.18175",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.865",
  "magpie-types": "/magpie-types/static-1.5050",
  "simple-logging-lib": "/simple-logging-lib/static-1.3107",
  "ai-studio-lib": "/ai-studio-lib/static-1.11774",
  "app-governance-lib": "/app-governance-lib/static-1.1729",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10570",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8059",
  "ui-product-approvals": "/ui-product-approvals/static-1.28319",
  "ui-tool-access": "/ui-tool-access/static-1.10206",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9204",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5824",
  "usage-tracker-public": "/usage-tracker-public/static-1.7218",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3630",
  "persist-promise": "/persist-promise/static-1.3756",
  "reference-resolvers": "/reference-resolvers/static-1.8229",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3982",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.393",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3075",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2933",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "atom": "/atom/static-1.5131",
  "purchase-motions-components": "/purchase-motions-components/static-1.6021",
  "salesImages": "/salesImages/static-1.526",
  "batch-promise": "/batch-promise/static-1.1599",
  "crm-component-utils": "/crm-component-utils/static-1.39224",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5946",
  "customer-data-properties": "/customer-data-properties/static-1.51781",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6947",
  "property-value-citations": "/property-value-citations/static-1.2395",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8156",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9114",
  "navigation-messaging": "/navigation-messaging/static-1.7502",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10097",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.991",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4870",
  "content-icons-ui": "/content-icons-ui/static-1.2242",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9882",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7306",
  "crm-message-bus": "/crm-message-bus/static-1.43115",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22428",
  "events-data-lib": "/events-data-lib/static-1.287",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4777",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4049",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6852",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1040",
  "onboarding-tours": "/onboarding-tours/static-1.16709",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13838",
  "academy-common-lib": "/academy-common-lib/static-1.13991",
  "content-assistance-lib": "/content-assistance-lib/static-1.7838",
  "dashboard-lib": "/dashboard-lib/static-1.81764",
  "file-manager-components": "/file-manager-components/static-1.23768",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18574",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18384",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18376",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19923",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8762",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4820",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11114",
  "user-context": "/user-context/static-1.5165",
  "growth-payments-core": "/growth-payments-core/static-1.25537",
  "reporting-plugins": "/reporting-plugins/static-1.10412",
  "reporting-reports": "/reporting-reports/static-1.67474",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.781",
  "nest": "/nest/static-1.290",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10684",
  "framework-listing-lib": "/framework-listing-lib/static-2.28842",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30852",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4307",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.214",
  "onboarding-scopes": "/onboarding-scopes/static-1.6518",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4923",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7716",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15008",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3634",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9423",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6024",
  "signup-constants": "/signup-constants/static-1.18971",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8113",
  "card-properties-lib": "/card-properties-lib/static-1.44361",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37279",
  "crm-actions": "/crm-actions/static-1.6396",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43750",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9426",
  "customer-data-tracking": "/customer-data-tracking/static-1.6946",
  "hs-resources": "/hs-resources/static-1.226",
  "pulse": "/pulse/static-1.644",
  "calling-global-api": "/calling-global-api/static-1.64713",
  "calling-internal-common": "/calling-internal-common/static-1.31362",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66095",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58389",
  "commerce-products-lib": "/commerce-products-lib/static-1.9764",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3841",
  "crm-links": "/crm-links/static-1.6364",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4183",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4266",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.689",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3736",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48940",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4010",
  "smart-property-lib": "/smart-property-lib/static-1.7412",
  "tiered-pricing": "/tiered-pricing/static-1.1346",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11047",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.66",
  "react-dnd-compat": "/react-dnd-compat/static-1.4671",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1036",
  "growth-data-modal": "/growth-data-modal/static-1.5515",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3124",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2079",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.775",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7654",
  "academy-service-client": "/academy-service-client/static-1.3740",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39267",
  "FileManagerLib": "/FileManagerLib/static-1.39408",
  "video-embed": "/video-embed/static-1.35966",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28716",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11474",
  "video-data-lib": "/video-data-lib/static-1.35132",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8522",
  "payment-link-components": "/payment-link-components/static-1.23658",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9943",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24499",
  "viral-links-lib": "/viral-links-lib/static-1.7127",
  "data-token-picker": "/data-token-picker/static-1.16504",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.284",
  "timezone-utils": "/timezone-utils/static-2.5300",
  "seat-types-lib": "/seat-types-lib/static-1.146",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17692",
  "ui-addon-opt": "/ui-addon-opt/static-4.8419",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9259",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25571",
  "framework-data-table": "/framework-data-table/static-2.12047",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6919",
  "nudge-client-utils": "/nudge-client-utils/static-1.2705",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1134",
  "switchboard-lib": "/switchboard-lib/static-1.280",
  "app-users-service-client": "/app-users-service-client/static-1.5662",
  "app-users-service-types": "/app-users-service-types/static-1.5070",
  "mini-checkout-client": "/mini-checkout-client/static-1.26944",
  "onboarding-utils": "/onboarding-utils/static-1.5415",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2056",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28701",
  "edison-service-client-types": "/edison-service-client-types/static-1.446",
  "crm_data": "/crm_data/static-4.92145",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46170",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16530",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4315",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19261",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18668",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10526",
  "crm-fe-perf": "/crm-fe-perf/static-1.22960",
  "event-emitter": "/event-emitter/static-1.1006",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.147",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31369",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11094",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6598",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1223",
  "commerce-permissions": "/commerce-permissions/static-1.832",
  "products-iframe-lib": "/products-iframe-lib/static-1.8089",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10481",
  "data-agent-kit": "/data-agent-kit/static-1.283",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10182",
  "policy-lib": "/policy-lib/static-1.6836",
  "react-tinymce": "/react-tinymce/static-1.55397",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10245",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54523",
  "tinymce-plugins": "/tinymce-plugins/static-1.57637",
  "tinymce-themes": "/tinymce-themes/static-1.56493",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2058",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2107",
  "user-context-client": "/user-context-client/static-1.4655",
  "audio-components": "/audio-components/static-1.5997",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36919",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4594",
  "video-components": "/video-components/static-1.13476",
  "outpost": "/outpost/static-1.4232",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6637",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12541",
  "content-media-compositions": "/content-media-compositions/static-2.16548",
  "media-bridge-lib": "/media-bridge-lib/static-1.19021",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6206",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5137",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21772",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3905",
  "ts-utils-lib": "/ts-utils-lib/static-1.228",
  "crm-export-dialog": "/crm-export-dialog/static-1.6347",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6500",
  "crm-view-components": "/crm-view-components/static-1.444",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7385",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2462",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2781",
  "whisper-core-api": "/whisper-core-api/static-1.6779",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14964",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5677",
  "settings-content-modals": "/settings-content-modals/static-1.46244",
  "crm_universal": "/crm_universal/static-1.22104",
  "customer-data-email": "/customer-data-email/static-1.18131",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37329",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39702",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12302",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54891",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21620",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18047",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72222",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5401",
  "utility-belt": "/utility-belt/static-1.2591",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23044",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7605",
  "customer-data-rte": "/customer-data-rte/static-1.33146",
  "cv-backend-services": "/cv-backend-services/static-1.1555",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5840",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5165",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38312",
  "trials-service-types": "/trials-service-types/static-1.3957",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36000",
  "sales-views-client-types": "/sales-views-client-types/static-1.4315",
  "hub-http-contrib": "/hub-http-contrib/static-1.3098",
  "interframe": "/interframe/static-3.4816",
  "tinymce-data": "/tinymce-data/static-1.40608",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5268",
  "layout-dnd-components": "/layout-dnd-components/static-1.12553",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11528",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15494",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9102",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7661",
  "social-insights-client-types": "/social-insights-client-types/static-1.22242",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4214",
  "checkout-sdk": "/checkout-sdk/static-3.23787",
  "checkout-service-types": "/checkout-service-types/static-1.3846",
  "company-details-components": "/company-details-components/static-1.6253",
  "payment-method-components": "/payment-method-components/static-1.6951",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14315",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3522",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3578",
  "access-control-lib": "/access-control-lib/static-1.10491",
  "EmailComponents": "/EmailComponents/static-1.54914",
  "EmailData": "/EmailData/static-1.53591",
  "redux-less": "/redux-less/static-2.9541",
  "sequences-lib": "/sequences-lib/static-1.8140",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10406",
  "products-ui-components": "/products-ui-components/static-1.40282",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7153",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54907",
  "commerce-products-api": "/commerce-products-api/static-1.2383",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56965",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102900",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80943",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28418",
  "ContentData": "/ContentData/static-1.68603",
  "layout-data-lib": "/layout-data-lib/static-1.9853",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.805",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3996",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4049",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.614",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18662",
  "pricing-pages-api": "/pricing-pages-api/static-1.14180",
  "ContentComponents": "/ContentComponents/static-2.71484",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10245",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1938",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46432",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1294",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19039",
  "automation-ui-types": "/automation-ui-types/static-1.19957",
  "messaging-types-lib": "/messaging-types-lib/static-1.46169",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4561",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7997",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.590",
  "price-books-api": "/price-books-api/static-1.1041",
  "price-books-components": "/price-books-components/static-1.1099",
  "property-description-translator": "/property-description-translator/static-1.3900",
  "ramp-editor": "/ramp-editor/static-1.280",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
  "totals-ui-components": "/totals-ui-components/static-1.23760",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9334",
  "advanced-menus-core": "/advanced-menus-core/static-1.15216",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12151",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34197",
  "segments-query-core": "/segments-query-core/static-1.1475",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3238",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5873",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7396",
  "data-token-views": "/data-token-views/static-1.16485",
  "forms-utils-lib": "/forms-utils-lib/static-1.12689",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13151",
  "simple-menus-core": "/simple-menus-core/static-1.15215",
  "simple-menus-lib": "/simple-menus-lib/static-1.16732",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6906",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7572",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3560",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2604",
  "ContentEditorUI": "/ContentEditorUI/static-2.77257",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4027",
  "web-interactives-components": "/web-interactives-components/static-1.13855",
  "web-interactives-data": "/web-interactives-data/static-1.13856",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.743",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.913",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1036",
  "line-items-api": "/line-items-api/static-1.784",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3863",
  "FireAlarmUi": "/FireAlarmUi/static-1.4557",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4214",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21893",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21356",
  "data-studio-ubb": "/data-studio-ubb/static-1.2882",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27163",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57975",
  "content-management-data-lib": "/content-management-data-lib/static-1.5465",
  "copilot-plugins": "/copilot-plugins/static-1.11258",
  "cta-picker": "/cta-picker/static-1.36556",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3243",
  "editor-components": "/editor-components/static-1.13314",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8485",
  "error-messaging-js": "/error-messaging-js/static-1.5250",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86004",
  "pictos": "/pictos/static-7.185",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10703",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1804",
  "smart-content-core": "/smart-content-core/static-1.42598",
  "smart-content-lib": "/smart-content-lib/static-1.43251",
  "social-composer-lib": "/social-composer-lib/static-1.59382",
  "structured-content-lib": "/structured-content-lib/static-1.25343",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53391",
  "tinymce-copilot": "/tinymce-copilot/static-1.16591",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7988",
  "automation-ui-routing": "/automation-ui-routing/static-1.21314",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5681",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42317",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3245",
  "reporting-enablement": "/reporting-enablement/static-1.23121",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21542",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2772",
  "forms-ai-lib": "/forms-ai-lib/static-1.4404",
  "codemirror-dlb": "/codemirror-dlb/static-1.58816",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6490",
  "report-customization-components": "/report-customization-components/static-1.13322",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13196",
  "reporting-filters": "/reporting-filters/static-1.472",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1905"
}
};
